import makeStyles from '@mui/styles/makeStyles';
import { rgba } from 'polished';

export const useStyles = makeStyles((theme) => ({
  summaryBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    background: '#fff',
    border: '1px solid #DADCE0',
    borderRadius: '8px',
    padding: '20px 24px',
    marginBottom: '24px',
    flexWrap: 'wrap',
  },
  summaryCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flex: 1,
    minWidth: '140px',
  },
  depositCard: {
    background: '#F0FFF4',
    borderRadius: '6px',
    padding: '10px 14px',
  },
  fallbackBanner: {
    background: '#FFFBEB',
    border: '1px solid #F2C94C',
    borderLeft: '4px solid #F57F17',
    borderRadius: '6px',
    padding: '12px 16px',
    marginBottom: '16px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '12px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  fallbackBannerText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flex: 1,
  },
  fallbackBannerTitle: {
    fontSize: '14px',
    fontWeight: 700,
    color: '#7A4F01',
  },
  fallbackBannerBody: {
    fontSize: '13px',
    color: '#5C3D02',
    lineHeight: 1.45,
  },
  fallbackBannerRetry: {
    color: '#7A4F01',
    fontWeight: 600,
    fontSize: '13px',
    textTransform: 'none',
    whiteSpace: 'nowrap',
    alignSelf: 'flex-start',
    '&:hover': {
      background: 'rgba(122, 79, 1, 0.08)',
    },
  },
  summaryLabel: {
    fontSize: '11px',
    color: rgba(0, 0, 0, 0.5),
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  summaryValue: {
    fontSize: '22px',
    fontWeight: 700,
    color: '#171725',
  },
  feeValue: {
    color: '#D32F2F',
  },
  depositValue: {
    color: '#2E7D32',
  },

  titleWrapperDesktop: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 14px',
    marginBottom: '8px',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  titleWrapperMobile: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '8px',
      minWidth: '1100px',
      paddingRight: '10px',
    },
  },

  columnTitle: {
    color: '#171725',
    opacity: 0.55,
    fontSize: '10px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.4px',
  },

  colDateTime: { flex: '2 0 95px' },
  colId: { flex: '1 0 70px' },
  colType: { flex: '1 0 70px' },
  colMenuPrice: { flex: '2 0 95px', textAlign: 'right' },
  colEatzyAmount: { flex: '2 0 100px', textAlign: 'right' },
  colEffectivePct: { flex: '1 0 60px', textAlign: 'right' },
  colStripeFee: { flex: '2 0 90px', textAlign: 'right' },
  colDeposit: { flex: '2 0 100px', textAlign: 'right' },
  colStatus: {
    flex: '1 0 95px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },

  payoutGroup: {
    background: '#fff',
    border: '1px solid #DADCE0',
    borderRadius: '6px',
    padding: '12px 14px',
    marginBottom: '16px',
    [theme.breakpoints.down('md')]: {
      maxWidth: 'calc(100VW - 30px)',
      overflowX: 'auto',
      overflowY: 'hidden',
    },
  },
  payoutHeaderRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    userSelect: 'none',
    marginBottom: '10px',
    paddingBottom: '10px',
    borderBottom: '1px solid #F0F0F0',
  },
  payoutHeader: {
    fontSize: '13px',
    fontWeight: 700,
    color: '#171725',
  },
  orderCount: {
    fontSize: '12px',
    fontWeight: 500,
    color: rgba(0, 0, 0, 0.45),
  },
  chevron: {
    color: rgba(0, 0, 0, 0.35),
    fontSize: '20px',
    flexShrink: 0,
    transition: 'transform 200ms ease',
  },
  chevronExpanded: {
    transform: 'rotate(180deg)',
  },
  wrapperDay: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      minWidth: '1100px',
      paddingRight: '10px',
    },
  },
  orderRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '7px 0',
    borderBottom: '1px solid #F9F9F9',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  orderRowEstimated: {
    background: '#FFFCF2',
    borderLeft: '3px solid #F57F17',
    paddingLeft: '6px',
  },
  detailRowsElsewhere: {
    fontSize: '12px',
    color: rgba(0, 0, 0, 0.55),
    fontStyle: 'italic',
    padding: '8px 0',
  },
  rowCell: {
    fontSize: '13px',
    color: '#171725',
    opacity: 0.75,
  },

  subtotalRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 0 4px',
    marginTop: '6px',
    borderTop: '2px solid #E8E8E8',
  },
  subtotalLabel: {
    fontSize: '11px',
    fontWeight: 700,
    color: '#0058FF',
    letterSpacing: '0.3px',
  },
  subtotalCell: {
    fontSize: '13px',
    fontWeight: 700,
    color: '#0058FF',
  },

  confirmedChip: {
    backgroundColor: '#E8F5E9',
    color: '#2E7D32',
    fontSize: '10px',
    fontWeight: 600,
    height: '20px',
    '& .MuiChip-icon': {
      color: '#2E7D32',
      fontSize: '13px',
      marginLeft: '4px',
      marginRight: '-2px',
    },
    '& .MuiChip-label': {
      paddingLeft: '6px',
      paddingRight: '8px',
    },
  },
  estimatedChip: {
    backgroundColor: '#FFF8E1',
    color: '#F57F17',
    fontSize: '10px',
    fontWeight: 600,
    height: '20px',
    cursor: 'help',
  },
  awaitingChip: {
    backgroundColor: '#E3F2FD',
    color: '#1565C0',
    fontSize: '10px',
    fontWeight: 600,
    height: '20px',
  },

  pendingTruncatedNotice: {
    background: '#FFF8E1',
    border: '1px solid #FFE082',
    borderRadius: '6px',
    padding: '10px 14px',
    marginBottom: '10px',
    fontSize: '13px',
    color: '#7A5A00',
  },
  pendingGroup: {
    background: '#fff',
    border: '1px solid #DADCE0',
    borderRadius: '6px',
    padding: '12px 14px',
    marginBottom: '16px',
    [theme.breakpoints.down('md')]: {
      maxWidth: 'calc(100VW - 30px)',
      overflowX: 'auto',
      overflowY: 'hidden',
    },
  },
  pendingHeaderWrap: {
    marginBottom: '10px',
    paddingBottom: '10px',
    borderBottom: '1px solid #F0F0F0',
  },
  pendingHeader: {
    fontSize: '13px',
    fontWeight: 700,
    color: '#171725',
  },
  pendingSubtitle: {
    fontSize: '12px',
    color: rgba(0, 0, 0, 0.55),
    marginTop: '2px',
  },
  hasDetails: {
    cursor: 'help',
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    textDecorationColor: rgba(0, 0, 0, 0.35),
  },

  summaryHint: {
    fontSize: '10px',
    color: rgba(0, 0, 0, 0.5),
    fontWeight: 500,
    marginTop: '2px',
    letterSpacing: '0.3px',
  },

  tooltipPaper: {
    maxWidth: 320,
    backgroundColor: '#1F2933',
    fontSize: '12px',
    padding: '10px 12px',
    lineHeight: 1.5,
  },
  tooltipBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  tooltipSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  tooltipSectionTitle: {
    fontSize: '10px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    opacity: 0.65,
    marginBottom: '2px',
  },
  tooltipLine: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '12px',
    fontVariantNumeric: 'tabular-nums',
  },
  tooltipTotal: {
    fontWeight: 700,
    borderTop: '1px solid rgba(255,255,255,0.15)',
    paddingTop: '4px',
    marginTop: '4px',
  },
  tooltipDeposit: {
    fontWeight: 700,
    color: '#7BE495',
    borderTop: '1px solid rgba(255,255,255,0.15)',
    paddingTop: '6px',
  },
  tooltipPassThroughGroup: {
    borderLeft: '2px solid rgba(255,255,255,0.15)',
    paddingLeft: '6px',
    marginBottom: '2px',
  },
  tooltipSubLabel: {
    fontSize: '10px',
    opacity: 0.55,
    marginBottom: '1px',
    fontStyle: 'italic',
  },
  tooltipPassThrough: {
    opacity: 0.7,
  },
  tooltipMenuPriceLine: {
    fontWeight: 600,
    borderTop: '1px solid rgba(255,255,255,0.1)',
    paddingTop: '3px',
    marginTop: '2px',
  },
  tooltipRefundLine: {
    color: '#FFCC80',
    opacity: 0.9,
  },

  groupWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  infoWrapper: {
    overflow: 'auto',
    maxHeight: '65vh',
    scrollbarWidth: 'thin',
    [theme.breakpoints.down('md')]: {
      scrollbarWidth: 'none',
    },
  },
  scrollWrapper: {
    [theme.breakpoints.down('md')]: {
      overflowX: 'auto',
      overflowY: 'hidden',
    },
  },
  noRecords: {
    color: rgba(0, 0, 0, 0.3),
    fontSize: 24,
    marginTop: '70px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },

  searchBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginBottom: '12px',
    padding: '5px 10px',
    border: '1px solid #DADCE0',
    borderRadius: '6px',
    background: '#fff',
    maxWidth: '320px',
    '&:focus-within': {
      borderColor: '#0058FF',
    },
  },
  searchInput: {
    flex: 1,
    fontSize: '13px',
    color: '#171725',
  },
  searchPageNote: {
    fontSize: '12px',
    color: rgba(0, 0, 0, 0.45),
    fontStyle: 'italic',
    marginBottom: '10px',
  },
  searchErrorNote: {
    fontSize: '12px',
    color: '#C62828',
    marginBottom: '10px',
  },
  searchLoadingIndicator: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginBottom: '10px',
  },
  revalidatingBanner: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginBottom: '10px',
  },
  revalidatingText: {
    fontSize: '12px',
    color: rgba(0, 0, 0, 0.45),
    fontStyle: 'italic',
  },
  searchAnnotation: {
    fontSize: '12px',
    color: rgba(0, 0, 0, 0.45),
    fontStyle: 'italic',
    padding: '4px 0 2px',
  },
  filterRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    [theme.breakpoints.down('md')]: {
      gap: '6px',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
    },
  },
  timezoneLabel: {
    fontSize: '12px',
    color: rgba(0, 0, 0, 0.55),
    whiteSpace: 'nowrap',
  },

  feeCellWithIndicator: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '4px',
  },
  unreconciledIcon: {
    color: '#D32F2F',
    fontSize: '16px',
    cursor: 'help',
    flexShrink: 0,
  },
  summaryValueRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  summaryUnreconciledIcon: {
    color: '#D32F2F',
    fontSize: '20px',
    cursor: 'help',
    flexShrink: 0,
  },

  depositSplitCell: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '2px',
  },
  depositSplitLine: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '4px',
  },
  depositSplitLabel: {
    fontSize: '9px',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
    color: rgba(0, 0, 0, 0.45),
    whiteSpace: 'nowrap',
  },
  depositSplitMissing: {
    fontSize: '13px',
    fontWeight: 700,
    color: rgba(0, 0, 0, 0.35),
    cursor: 'help',
  },

  badgeReconciled: {
    backgroundColor: '#E8F5E9',
    color: '#1B5E20',
    fontSize: '10px',
    fontWeight: 600,
    height: '20px',
    cursor: 'default',
    '& .MuiChip-icon': {
      color: '#2E7D32',
      fontSize: '13px',
      marginLeft: '4px',
      marginRight: '-2px',
    },
    '& .MuiChip-label': {
      paddingLeft: '6px',
      paddingRight: '8px',
    },
  },
  badgeVarianceMinor: {
    backgroundColor: '#FFF8E1',
    color: '#7A5A00',
    fontSize: '10px',
    fontWeight: 600,
    height: '20px',
    cursor: 'help',
    '& .MuiChip-icon': {
      color: '#F57F17',
      fontSize: '13px',
      marginLeft: '4px',
      marginRight: '-2px',
    },
    '& .MuiChip-label': {
      paddingLeft: '6px',
      paddingRight: '8px',
    },
  },
  badgeVarianceMajor: {
    backgroundColor: '#FFEBEE',
    color: '#B71C1C',
    fontSize: '10px',
    fontWeight: 600,
    height: '20px',
    cursor: 'help',
    '& .MuiChip-icon': {
      color: '#D32F2F',
      fontSize: '13px',
      marginLeft: '4px',
      marginRight: '-2px',
    },
    '& .MuiChip-label': {
      paddingLeft: '6px',
      paddingRight: '8px',
    },
  },
  badgeAwaiting: {
    backgroundColor: '#F5F5F5',
    color: rgba(0, 0, 0, 0.5),
    fontSize: '10px',
    fontWeight: 500,
    height: '20px',
    cursor: 'help',
    '& .MuiChip-label': {
      paddingLeft: '8px',
      paddingRight: '8px',
    },
  },
}));
